module.exports = __webpack_public_path__ + "img/cars.62864b5d.webp";